import React from 'react'
import {Card, Container, Row, Col} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const PolitiqueConfidentialite = () => {
    const { t } = useTranslation();
    
    return (
        <>
            <Container>
                <Container fluid>
                    <Row>
                        <Col lg="12">
                            <br/>
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">{t("Politique de Confidentialité")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Dernière mise à jour : Février 2025")}</p>
                                    <p>{t("Chez SEEKS.BIZ, la protection de vos données personnelles est une priorité. Cette politique décrit quelles données nous collectons, pourquoi, comment nous les utilisons, et vos droits en tant qu'utilisateur professionnel.")}</p>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">1. {t("Qui est responsable du traitement des données ?")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>ONYRIX SOFTWARE<br />
                                    SAS au capital de 1 000 €<br />
                                    RCS Béziers : 935 385 559<br />
                                    Siège social : 49 Boulevard de l'Europe, 34500 Béziers<br />
                                    Contact : contact@seeks.biz</p>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">2. {t("Quelles données collectons-nous ?")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Lors de votre utilisation de SEEKS.BIZ, nous collectons :")}</p>
                                    <ul>
                                        <li>{t("Données d'inscription : nom, prénom, adresse email professionnelle, téléphone (facultatif), SIRET/KBIS, secteur d'activité.")}</li>
                                        <li>{t("Données d'utilisation : mots-clés/mots-hameçons, connexions, publications, interactions.")}</li>
                                        <li>{t("Données de navigation : cookies, adresse IP, type de terminal, temps de connexion.")}</li>
                                        <li>{t("Données de facturation (abonnés payants) : coordonnées de facturation, historique des paiements.")}</li>
                                    </ul>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">3. {t("Pourquoi collectons-nous ces données ?")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Les données sont utilisées pour :")}</p>
                                    <ul>
                                        <li>{t("Gérer l'accès et l'authentification à votre compte.")}</li>
                                        <li>{t("Optimiser la mise en relation entre professionnels via notre algorithme.")}</li>
                                        <li>{t("Assurer un service client efficace.")}</li>
                                        <li>{t("Améliorer nos services (analyse statistique, retours utilisateurs).")}</li>
                                        <li>{t("Envoyer des informations sur les nouveautés, mises à jour ou offres (avec votre consentement).")}</li>
                                        <li>{t("Respecter nos obligations légales (ex. : facturation, sécurité des données).")}</li>
                                    </ul>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">4. {t("Qui a accès à vos données ?")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Vos données sont accessibles :")}</p>
                                    <ul>
                                        <li>{t("À notre équipe technique et support client.")}</li>
                                        <li>{t("À nos prestataires de services techniques (hébergement OVH, outils d'emailing, paiement sécurisé).")}</li>
                                        <li>{t("Aux autorités judiciaires en cas d'obligation légale.")}</li>
                                    </ul>
                                    <p>{t("Nous ne revendons aucune donnée personnelle. Seules des données statistiques anonymes peuvent être partagées avec des partenaires à des fins d'analyse ou de reporting. Ces données ne permettent pas d'identifier un utilisateur individuellement.")}</p>
                                    <p>{t("Nous ne vendons jamais vos données à des tiers sans votre consentement explicite.")}</p>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">5. {t("Durée de conservation")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Vos données sont conservées :")}</p>
                                    <ul>
                                        <li>{t("Tant que votre compte est actif.")}</li>
                                        <li>{t("Jusqu'à 3 ans après la dernière activité (ou suppression du compte) pour des raisons administratives.")}</li>
                                        <li>{t("Jusqu'à 10 ans pour les données de facturation (obligation légale).")}</li>
                                    </ul>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">6. {t("Vos droits")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Conformément au RGPD, vous disposez des droits suivants :")}</p>
                                    <ul>
                                        <li>{t("Droit d'accès à vos données.")}</li>
                                        <li>{t("Droit de rectification de vos informations.")}</li>
                                        <li>{t("Droit à l'effacement (\"droit à l'oubli\").")}</li>
                                        <li>{t("Droit d'opposition ou de limitation du traitement.")}</li>
                                        <li>{t("Droit à la portabilité de vos données.")}</li>
                                    </ul>
                                    <p>{t("Pour exercer ces droits, écrivez à : contact@seeks.biz")}</p>
                                    <p>{t("Une réponse vous sera donnée sous 30 jours maximum.")}</p>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">7. {t("Sécurité des données")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("SEEKS met en œuvre toutes les mesures nécessaires (chiffrement, accès restreint, sauvegardes) pour protéger vos données contre toute perte, accès non autorisé ou modification.")}</p>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">8. {t("Cookies")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Des cookies sont utilisés pour :")}</p>
                                    <ul>
                                        <li>{t("Le bon fonctionnement du site.")}</li>
                                        <li>{t("L'analyse de l'audience.")}</li>
                                        <li>{t("La personnalisation des contenus.")}</li>
                                    </ul>
                                    <p>{t("Voir notre Politique de cookies pour gérer vos préférences.")}</p>
                                </Card.Body>
                            </Card>
                            
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">9. {t("Modification de la politique")}</h4>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <p>{t("Cette politique peut être mise à jour. En cas de changement important, nous vous en informerons par email ou via votre tableau de bord SEEKS.")}</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </>
    )
}

export default PolitiqueConfidentialite
